<template>
  <div>
    <vs-card title="Filtrar búsqueda">
      <div class="grid grid-cols-5 gap-2 h-56 content-center">
        <div>
          <label>Fecha de inicio</label>
          <date-picker :date="privateStartDate" :option="datePickerOption" placeholder="Fecha de inicio" />
        </div>
        <div>
          <label>Fecha de fin</label>
          <date-picker :date="privateEndDate" :option="datePickerOption" placeholder="Fecha de fin"
            @change="onEndDateChange" />
        </div>
        <div>
          <vs-button class="mt-6" @click="searchDateFilterHandler">
            Buscar
          </vs-button>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import myDatepicker from 'vue-datepicker';

export default {
  name: "recurrent-commission-finder",
  components: {
    'date-picker': myDatepicker
  },
  data() {
    return {
      privateStartDate: { time: this.startDate || '' },
      privateEndDate: { time: this.endDate || '' },
      datePickerOption: {
        type: 'day',
        week: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
        month: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        format: 'YYYY-MM-DD',
        placeholder: 'Seleccionar fecha',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #ccc',
          'border-radius': '4px',
          'width': '100%'
        }
      }
    }
  },
  watch: {
    startDate() {
      this.privateStartDate = { time: this.startDate || '' };
      this.privateEndDate = { time: this.endDate || '' };
    }
  },
  props: {
    startDate: {
      type: String | null,
      required: true
    },
    endDate: {
      type: String | null,
      required: true
    }
  },
  methods: {
    onEndDateChange() {
      // Método llamado cuando cambia la fecha de fin
      // Puedes agregar validaciones aquí si es necesario
    },
    searchDateFilterHandler() {
      this.$emit('onChangeDate', {
        startDate: this.privateStartDate.time,
        endDate: this.privateEndDate.time,
      })
    }
  }
}
</script>
